export const prdSchemes = [
  // {
  //   district: "ZILA PARISHAD\nGIRIDIH",
  //   ddo: "DDC-cum-CEO ZILA PARISHAD GIRIDIH",
  //   ddoCode: "GRDDAD029",
  //   "plAccountDetails_accountNo": "84480010157000679",
  //   financialYear: "2023-24",
  //   schemeName:
  //     "Construction of Panchayat Bhawan G.P Karodih under Jamua Block.",
  //   block: "Jamua",
  //   panchayat: "Karodih",
  //   landAddress:
  //     "Lat-   24.296416º\nLong-86.224745º\nG.M Land\nKhata-61\nPlot-569\nRakwa-4.53 Acr",
  //   latitude: 24.296416,
  //   longitude: 86.224745,
  //   sector: "Asset Creation",
  //   subSector: "G.P. Bhawan",
  //   utilityPurpose: "G.P \nAdministration",
  //   feasibilityStudy: "Good",
  //   dpr: "Enclosed",
  //   technicalSanctionAuthority: "S.E.\n JPHCL\n Ranchi",
  //   technicalSanctionAmount: 9989000,
  //   administrativeApprovalAuthority: "03.02.2024",
  //   allocatedAmount: 9936687,
  //   tenderStatus: "Complete",
  //   workOrderDate: "07.06.2024",
  //   agencyName: "BABA\nCONTRACTORS\nPVT LTD",
  //   schemeStartDate: "07.06.2024",
  //   completionDate: "06.06.2025",
  //   schemeStatus: "Complete",
  //   lastMBStatus: "3rd Cum\n Running",
  //   paymentStatus: "On Going",
  //   amountRemaining: 100290,
  // },
  // {
  //   district: "ZILA PARISHAD\nGIRIDIH",
  //   ddo: "DDC-cum-CEO ZILA PARISHAD GIRIDIH",
  //   ddoCode: "GRDDAD030",
  //   "plAccountDetails - A/N": "84480010157000679",
  //   financialYear: "2023-25",
  //   schemeName:
  //     "Construction of Panchayat Bhawan G.P Sriramdih under Dhanwar Block.",
  //   block: "Dhanwar",
  //   panchayat: "Sriramdih",
  //   landAddress:
  //     "Lat-   24.351426º\nLong-85.946234º\nG.M Land\nKhata-05\nPlot-111\nRakwa-5.69 Acr",
  //   latitude: 24.351426,
  //   longitude: 85.946234,
  //   sector: "Asset Creation",
  //   subSector: "G.P. Bhawan",
  //   utilityPurpose: "G.P \nAdministration",
  //   feasibilityStudy: "Good",
  //   dpr: "Enclosed",
  //   technicalSanctionAuthority: "S.E.\n JPHCL\n Ranchi",
  //   technicalSanctionAmount: 9989000,
  //   administrativeApprovalAuthority: "03.02.2024",
  //   allocatedAmount: 9981290,
  //   tenderStatus: "Complete",
  //   workOrderDate: "07.06.2024",
  //   agencyName: "SRI INDRADEO SINGH",
  //   schemeStartDate: "07.06.2024",
  //   completionDate: "06.06.2025",
  //   schemeStatus: "Complete",
  //   lastMBStatus: "3rd Cum\n Running",
  //   paymentStatus: "On Going",
  //   amountRemaining: 272566,
  // },
  // {
  //   district: "ZILA PARISHAD\nGIRIDIH",
  //   ddo: "DDC-cum-CEO ZILA PARISHAD GIRIDIH",
  //   ddoCode: "GRDDAD031",
  //   "plAccountDetails - A/N": "84480010157000679",
  //   financialYear: "2023-26",
  //   schemeName:
  //     "Construction of Panchayat Bhawan G.P Pawapur under Suriya Block.",
  //   block: "suriya",
  //   panchayat: "Pawapur",
  //   landAddress:
  //     "Lat-   24.157209º\nLong-85.923979º\nG.M Land\nKhata-31\nPlot-738\nRakwa-0.40 Acr",
  //   latitude: 24.157209,
  //   longitude: 85.923979,
  //   sector: "Asset Creation",
  //   subSector: "G.P. Bhawan",
  //   utilityPurpose: "G.P \nAdministration",
  //   feasibilityStudy: "Good",
  //   dpr: "Enclosed",
  //   technicalSanctionAuthority: "S.E.\n JPHCL\n Ranchi",
  //   technicalSanctionAmount: 9989000,
  //   administrativeApprovalAuthority: "03.02.2024",
  //   allocatedAmount: 9983141,
  //   tenderStatus: "Complete",
  //   workOrderDate: "07.06.2024",
  //   agencyName: "SRI VIKASH KUMAR",
  //   schemeStartDate: "07.06.2024",
  //   completionDate: "06.06.2025",
  //   schemeStatus: "Complete",
  //   lastMBStatus: "4th \n Final",
  //   paymentStatus: "Complete",
  //   amountRemaining: null,
  // },
  // {
  //   district: "ZILA PARISHAD\nGIRIDIH",
  //   ddo: "DDC-cum-CEO ZILA PARISHAD GIRIDIH",
  //   ddoCode: "GRDDAD032",
  //   "plAccountDetails - A/N": "84480010157000679",
  //   financialYear: "2023-27",
  //   schemeName:
  //     "Construction of Panchayat Bhawan G.P Purnidih under Suriya Block.",
  //   block: "suriya",
  //   panchayat: "Purnidih",
  //   landAddress:
  //     "Lat-   24.160537º\nLong-86.019485º\nG.M Land\nKhata-60\nPlot-469\nRakwa-5.83 Acr",
  //   latitude: 24.160537,
  //   longitude: 86.019485,
  //   sector: "Asset Creation",
  //   subSector: "G.P. Bhawan",
  //   utilityPurpose: "G.P \nAdministration",
  //   feasibilityStudy: "Good",
  //   dpr: "Enclosed",
  //   technicalSanctionAuthority: "S.E.\n JPHCL\n Ranchi",
  //   technicalSanctionAmount: 9989000,
  //   administrativeApprovalAuthority: "03.02.2024",
  //   allocatedAmount: 9837534,
  //   tenderStatus: "Complete",
  //   workOrderDate: "07.06.2024",
  //   agencyName: "SRI SUBHAM KUMAR",
  //   schemeStartDate: "07.06.2024",
  //   completionDate: "06.06.2025",
  //   schemeStatus: "Complete",
  //   lastMBStatus: "3rd Cum\n Running",
  //   paymentStatus: "On Going",
  //   amountRemaining: 2187240,
  // },
  // {
  //   district: "ZILA PARISHAD\nGIRIDIH",
  //   ddo: "DDC-cum-CEO ZILA PARISHAD GIRIDIH",
  //   ddoCode: "GRDDAD033",
  //   "plAccountDetails - A/N": "84480010157000679",
  //   financialYear: "2023-28",
  //   schemeName:
  //     "Construction of Panchayat Bhawan G.P Chhachhando under Dumri Block.",
  //   block: "Dumri",
  //   panchayat: "Chhachhando",
  //   landAddress:
  //     "Lat-   24.036646º\nLong-86.111438º\nG.M Land\nKhata-49\nPlot-588\nRakwa-0.53 Acr",
  //   latitude: 24.036646,
  //   longitude: 86.111438,
  //   sector: "Asset Creation",
  //   subSector: "G.P. Bhawan",
  //   utilityPurpose: "G.P \nAdministration",
  //   feasibilityStudy: "Good",
  //   dpr: "Enclosed",
  //   technicalSanctionAuthority: "S.E.\n JPHCL\n Ranchi",
  //   technicalSanctionAmount: 9989000,
  //   administrativeApprovalAuthority: "03.02.2024",
  //   allocatedAmount: 9978163,
  //   tenderStatus: "80%",
  //   workOrderDate: "07.06.2024",
  //   agencyName: "CHANDADIH CONSTRUCTION PVT LTD",
  //   schemeStartDate: "07.06.2024",
  //   completionDate: "06.06.2025",
  //   schemeStatus: "On Going",
  //   lastMBStatus: "2nd Cum Running",
  //   paymentStatus: "On Going",
  //   amountRemaining: 4243035,
  // },
  // {
  //   district: "ZILA PARISHAD\nGIRIDIH",
  //   ddo: "DDC-cum-CEO ZILA PARISHAD GIRIDIH",
  //   ddoCode: "GRDDAD034",
  //   "plAccountDetails - A/N": "84480010157000679",
  //   financialYear: "2023-29",
  //   schemeName:
  //     "Renovation of of Panchayat Bhawan Tirla, Jarmune, Dewradih  under Bagodar Block.",
  //   block: "Bagodar",
  //   panchayat: "Tirla",
  //   landAddress: "Lat-   24.037832\nLong-85.887665\n",
  //   sector: "Asset Creation",
  //   subSector: "G.P. Bhawan",
  //   utilityPurpose: "G.P \nAdministration",
  //   feasibilityStudy: "Good",
  //   dpr: "Enclosed",
  //   technicalSanctionAuthority: "S.E.\n JPHCL\n Ranchi",
  //   technicalSanctionAmount: 392500,
  //   administrativeApprovalAuthority: "03.02.2025",
  //   allocatedAmount: 281083,
  //   tenderStatus: "100%",
  //   workOrderDate: "31.08.2024",
  //   agencyName: "BHAGWAT PANDIT",
  //   schemeStartDate: "31.08.2024",
  //   completionDate: "30.11.2024",
  //   schemeStatus: "Complete",
  //   lastMBStatus: "2nd Final",
  //   paymentStatus: "Complete",
  //   amountRemaining: 111417,
  // },
  // {
  //   district: "ZILA PARISHAD\nGIRIDIH",
  //   ddo: "DDC-cum-CEO ZILA PARISHAD GIRIDIH",
  //   ddoCode: "GRDDAD035",
  //   "plAccountDetails - A/N": "84480010157000679",
  //   financialYear: "2023-30",
  //   schemeName:
  //     "Renovation of of Panchayat Bhawan Tirla, Jarmune, Dewradih  under Bagodar Block.",
  //   block: "Bagodar",
  //   panchayat: "Jarmune",
  //   landAddress: "Lat-   24.070688\nLong-85.802457\n",
  //   latitude: 24.070688,
  //   longitude: 85.802457,
  //   sector: "Asset Creation",
  //   subSector: "G.P. Bhawan",
  //   utilityPurpose: "G.P \nAdministration",
  //   feasibilityStudy: "Good",
  //   dpr: "Enclosed",
  //   technicalSanctionAuthority: "S.E.\n JPHCL\n Ranchi",
  //   technicalSanctionAmount: 392500,
  //   administrativeApprovalAuthority: "03.02.2026",
  //   allocatedAmount: 281083,
  //   tenderStatus: "100%",
  //   workOrderDate: "31.08.2025",
  //   agencyName: "BHAGWAT PANDIT",
  //   schemeStartDate: "31.08.2024",
  //   completionDate: "30.11.2025",
  //   schemeStatus: "Complete",
  //   lastMBStatus: "3rd Final",
  //   paymentStatus: "Complete",
  //   amountRemaining: 111417,
  // },
  // {
  //   district: "ZILA PARISHAD\nGIRIDIH",
  //   ddo: "DDC-cum-CEO ZILA PARISHAD GIRIDIH",
  //   ddoCode: "GRDDAD036",
  //   "plAccountDetails - A/N": "84480010157000679",
  //   financialYear: "2023-31",
  //   schemeName:
  //     "Renovation of of Panchayat Bhawan Tirla, Jarmune, Dewradih  under Bagodar Block.",
  //   block: "Bagodar",
  //   panchayat: "Dewradih",
  //   landAddress: "Lat-   24º8'3\"\nLong-85º53'34\"\n",
  //   latitude: 24.134166,
  //   longitude: 85.892778,
  //   sector: "Asset Creation",
  //   subSector: "G.P. Bhawan",
  //   utilityPurpose: "G.P \nAdministration",
  //   feasibilityStudy: "Good",
  //   dpr: "Enclosed",
  //   technicalSanctionAuthority: "S.E.\n JPHCL\n Ranchi",
  //   technicalSanctionAmount: 392500,
  //   administrativeApprovalAuthority: "03.02.2027",
  //   allocatedAmount: 281083,
  //   tenderStatus: "100%",
  //   workOrderDate: "31.08.2026",
  //   agencyName: "BHAGWAT PANDIT",
  //   schemeStartDate: "31.08.2024",
  //   completionDate: "30.11.2026",
  //   schemeStatus: "Complete",
  //   lastMBStatus: "4th Final",
  //   paymentStatus: "Complete",
  //   amountRemaining: 111417,
  // },

  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD034",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "बस पडाव बरवाडीह में दूकान निर्माण।",
    block: "Barwadih",
    panchayat: "Barwadih",
    landAddress: "ष्ज्ञींजं छवण्188 च्सवजण्1063",
    sector: "New Asset Creation",
    subSector: "Shop",
    utilityPurpose:
      "स्थानीय लोगों को रोजगार की व्यवस्था एवं जिला परिषद के आय श्रोत में वृद्धि",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "Yes",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 3951430,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD035",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "डाक बंगला निर्माण।",
    block: "Manika",
    panchayat: "Manika",
    landAddress: "1.25 एकड पुरानी परती काबिल आबाद।ष्",
    sector: "New Asset Creation",
    subSector: "Dak Bungalow",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "Yes",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 14615900,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD036",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "डाक बंगला निर्माण।",
    block: "Barwadih",
    panchayat: "Betla",
    landAddress: "खाता- 378 प्लाॅट-1553 रकबा-0.50 एकड",
    sector: "New Asset Creation",
    subSector: "Dak Bungalow",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "Yes",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 14615900,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD037",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "डाक बंगला निर्माण।",
    block: "Chandwa",
    panchayat: "Chandwa East",
    landAddress: "खाता- 103 प्लाॅट-3,48 रकबा-5.00 एकड",
    sector: "New Asset Creation",
    subSector: "Dak Bungalow",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "Yes",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 14615900,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD038",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "दूकान निर्माण भाग-1",
    block: "Mahuadanr",
    panchayat: "Mahuadanr",
    landAddress: "खाता- 285 प्लाॅट-177-180 रकबा-2.42 एकड",
    sector: "New Asset Creation",
    subSector: "Shop",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "Yes",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 3293730,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD039",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "दूकान निर्माण भाग-2",
    block: "Mahuadanr",
    panchayat: "Mahuadanr",
    landAddress: "खाता- 137 प्लाॅट-224 रकबा-3.28 एकड",
    sector: "New Asset Creation",
    subSector: "Shop",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "Yes",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 3449320,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD040",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "बस पडाव बालूमाथ में प्रवेश द्वार का निर्माण।",
    block: "Balumath",
    panchayat: "Balumath",
    landAddress: "खाता- 137 प्लाॅट-224 रकबा-3.28 एकड",
    sector: "New Asset Creation",
    subSector: "Bus Stand",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "Yes",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 651700,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD041",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "बस पडाव बालूमाथ में टिकट काउण्टर एवं पेयजल व्यवस्था।",
    block: "Balumath",
    panchayat: "Balumath",
    landAddress: "खाता- 71 प्लाॅट-323 रकबा-3.97 एकड",
    sector: "New Asset Creation",
    subSector: "Bus Stand",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "Yes",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 1054600,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD042",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "बस पडाव बरवाडीह में शौचालय",
    block: "Barwadih",
    panchayat: "Barwadih",
    landAddress: "खाता- 71 प्लाॅट-323 रकबा-3.97 एकड",
    sector: "New Asset Creation",
    subSector: "Bus Stand Toilet",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "Yes",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 1177900,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD043",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "बस पडाव चन्दवा में मार्केट कम्पलेक्स निर्माण।",
    block: "Chandwa",
    panchayat: "Chandwa East",
    landAddress: "ष्ज्ञींजं छव.188 च्सवज.1063",
    sector: "New Asset Creation",
    subSector: "Market Complex",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "No",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 5788961,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD044",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "बस पडाव चन्दवा में यात्री शेड निर्माण।",
    block: "Chandwa",
    panchayat: "Chandwa East",
    landAddress: "1.25 एकड पुरानी परती काबिल आबाद।ष्",
    sector: "New Asset Creation",
    subSector: "Bus Stand Shed",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "Yes",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 916800,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD045",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "माडल डाक बंगला का चाहरदिवारी रंग-रोगन",
    block: "Mahuadanr",
    panchayat: "Mahuadanr",
    landAddress: "खाता- 285 प्लाॅट-177-180 रकबा-2.42 एकड",
    sector: "Repair",
    subSector: "Dak Bungalow Boundry Wall",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "No",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 417512,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD046",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "बस पडाव बालूमाथ में 40 दूकान मरम्मति।",
    block: "Balumath",
    panchayat: "Balumath",
    landAddress: "खाता- 285 प्लाॅट-177-180 रकबा-2.42 एकड",
    sector: "Repair",
    subSector: "Shop ",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "No",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 2325800,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD047",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "बस पडाव बालूमाथ में 43 दूकान मरम्मति।",
    block: "Balumath",
    panchayat: "Balumath",
    landAddress: "खाता- 137 प्लाॅट-224 रकबा-3.28 एकड",
    sector: "Repair",
    subSector: "Shop ",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "No",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 2243900,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD048",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "बस पडाव चन्दवा के 101 दूकान की मरम्मति।",
    block: "Chandwa",
    panchayat: "Chandwa East",
    landAddress: "खाता- 71 प्लाॅट-323 रकबा-3.97 एकड",
    sector: "Repair",
    subSector: "Shop ",
    utilityPurpose: "जिला परिषद को आय श्रोत में वृद्धि होगी।",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "No",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 9668700,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD049",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName: "जिला ग्रामीण विकास भवन का मरम्मति।",
    block: "Latehar",
    panchayat: "Nagar Panchayat",
    landAddress: "खाता- 71 प्लाॅट-323 रकबा-3.97 एकड",
    sector: "Repair",
    subSector: "Office renovation,",
    utilityPurpose: "कार्यालय कार्य",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "No",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 1692700,
  },
  {
    district: "Zila Parishad Latehar",
    ddcCumCEOName: "Sayyed Riyaj Ahemad  (I.A.S)",
    districtEngineerName: "LAL BIHARI YADAV",
    ddo: "DDC-cum-CEO ZP Latehar",
    ddoCode: "LTRDAD050",
    "plAccountDetails - A/N": 8448,
    financialYear: "2025-26",
    schemeName:
      "अध्यक्ष@उपाध्यक्ष] जिला परिषद के कार्यालय प्रकोष्ट की मरम्मति।",
    block: "Latehar",
    panchayat: "Nagar Panchayat",
    landAddress: "खाता- 285 प्लाॅट-177-180 रकबा-2.42 एकड",
    sector: "Repair",
    subSector: "Office renovation,",
    utilityPurpose: "कार्यालय कार्य",
    needAssessment: "Yes",
    revenueGeneration: "Yes",
    boardApproval: "No",
    dpr: "Yes",
    technicalSanctionAuthority: "Yes",
    technicalSanctionAmount: 1873200,
  },
];
